import React, { useState, useEffect } from "react";

const COOKIE_KEY = "pomtask_cookie_consent";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      width: "100%",
      background: "#222",
      color: "#fff",
      padding: "16px 0",
      textAlign: "center",
      zIndex: 9999
    }}>
      <span>
        PomTask solo usa cookies técnicas para el inicio de sesión. Al continuar aceptas su uso.
      </span>
      <button
        onClick={acceptCookies}
        style={{
          marginLeft: 16,
          background: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: 4,
          padding: "6px 16px",
          cursor: "pointer"
        }}
      >
        Aceptar
      </button>
    </div>
  );
};

export default CookieBanner;